import { render, staticRenderFns } from "./ExpandedViewContent.vue?vue&type=template&id=465c4c7e"
import script from "./ExpandedViewContent.vue?vue&type=script&lang=js"
export * from "./ExpandedViewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports